// extracted by mini-css-extract-plugin
export default {"Article":"index__Article--F1EJd","article":"index__Article--F1EJd"};